__turbopack_context__.v({
  "className": "playfair_display_d69e2d36-module__mOdM7q__className",
});
